import { Component, OnInit ,Input,OnChanges, Output, EventEmitter} from '@angular/core';

@Component({
  selector: 'app-subject-progress',
  templateUrl: './subject-progress.component.html',
  styleUrls: ['./subject-progress.component.css']
})
export class SubjectProgressComponent implements OnInit, OnChanges {
  @Input() data: any ;
  @Input() currentSubject: any;
  @Input() subjects: any;
 // @Input() labels : any;
 @Output()
 change: EventEmitter<number> = new EventEmitter<number>();

  selectedSubjectProgress : any;
  selectedCurrentSubject: any;
  allSubjects :any;

  constructor() { }

  ngOnInit() {
    this.selectedSubjectProgress = this.data;
    this.allSubjects = this.subjects;
  }
  ngOnChanges(){
    this.allSubjects = this.subjects;
    this.selectedSubjectProgress = this.data;
    this.selectedCurrentSubject = this.currentSubject;
  }

  clickOnSubject(subject){
    this.change.emit(subject);
  }

}



// WEBPACK FOOTER //
// /usr/share/nginx/grade5_live/grade5-frontend-2.0/src/app/core-modules/statistics/shared/subject-progress/subject-progress.component.ts